import { connect } from 'react-redux';

import SearchResults from 'components/SearchResults';
import ShopifySearchProduct from 'models/ShopifySearchProduct';
import Log from 'utils/Log';

const mapStateToProps = (state, ownProps) => {
  const { searchResults } = ownProps;

  const items = searchResults?.reduce((itemsTransformed, productSearch) => {
    const formattedProduct = new ShopifySearchProduct(productSearch?.node);
    const colorwayProduct = {
      url: formattedProduct.url,
      handle: formattedProduct.handle,
      masterName: formattedProduct.masterName,
      colorName: formattedProduct.colorName,
      price: formattedProduct.formattedPrice,
      compareAtPrice: formattedProduct.formattedCompareAtPrice,
      image: formattedProduct.image,
      trackingParameters: formattedProduct.trackingParameters,
    };

    // Validate required props on ColorwayCard
    if (
      colorwayProduct?.url &&
      colorwayProduct?.masterName &&
      colorwayProduct?.price &&
      colorwayProduct?.image?.src
    ) {
      itemsTransformed.push(colorwayProduct);
    } else {
      Log.warn(
        `Shopify Search - Transformation - Search Page - Incomplete product - id: ${productSearch?.node?.id}`
      );
    }

    return itemsTransformed;
  }, []);

  return {
    items,
    ...ownProps,
  };
};

export default connect(mapStateToProps)(SearchResults);
